import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type {
  GTMEventGlycerinButtonClick,
  GTMEventGlycerinFormSubmitClick,
} from '@packages/tracking/src/types/events';
import type {
  GlycerinButtonClickPayload,
  GlycerinFormSubmitClickPayload,
} from '@packages/tracking/src/types/payloads';

export const useButtonClickTracking = () => {
  const dispatchGTMEvent = useTracking();

  const dispatchButtonClickTracking = (
    clickTrackingProps: GlycerinButtonClickPayload | GlycerinFormSubmitClickPayload | null,
    type?: 'button' | 'submit' | 'reset',
  ) => {
    const { category, target, detail, label, placement, variantIds, custom } =
      clickTrackingProps ?? {};

    if (clickTrackingProps !== null) {
      if (type === 'submit') {
        dispatchGTMEvent<GTMEventGlycerinFormSubmitClick>({
          event: 'FormSubmitClick',
          FormSubmitClickData: {
            category: category ?? 'form-submit-click',
            target,
            detail,
            label,
            placement,
            formId:
              clickTrackingProps && 'formId' in clickTrackingProps
                ? clickTrackingProps.formId
                : undefined,
            variantIds,
            custom,
          },
        });
      } else {
        dispatchGTMEvent<GTMEventGlycerinButtonClick>({
          event: 'ButtonClick',
          ButtonClickData: {
            category: category ?? 'button-click',
            target,
            detail,
            label,
            placement,
            variantIds,
            custom,
          },
        });
      }
    }
  };

  return {
    dispatchButtonClickTracking,
  };
};
